export default {
  clinical: 'clinical',
  marketing: 'marketing',
  tests: 'tests',
  system: 'system',
  rating: 'rating',
}
